import React from "react";
import DatePicker from './DatePicker'
import FixButton from './Button'
import Cookies from 'universal-cookie';
import moment from 'moment';
import GetInsegnanti from '../services/getInsegnanti';
import SelectInput from './SelectInput'
import TextInput from "./TextInput";

export default class FusioneWidget extends React.Component {

    constructor (props){
        super(props);

        this.daDateRef = React.createRef();
        this.aDateRef = React.createRef();

    }

    async componentDidMount(){
    
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        this.insegnanti = await GetInsegnanti(username, token);

        this.insegnantiArray = [];
        this.insegnanti.map(r => {
            this.insegnantiArray.push({value: r.id, label: r.cognome + ' ' + r.nome});
        });

        this.setState({
            nomeComposto: '',
            visible: this.props.show,
            insegnanti: [],
            insegnantiArray: this.insegnantiArray
        });

    }

    render (){

        if (!this.state) return <div />;
        let st = Object.assign({display: this.state.visible ? 'block' : 'none'}, mainClass);

        return ( 
        <div style={st} >
            <div style={closeIcon} onClick={() => {
                this.setState({visible: false});
                this.props.onCancel();
            }}>X</div>
            <div style={{marginTop: '10px'}}>
                <div className="windowTitle">Fusione insegnanti</div>

                <TextInput name={'Nome composto'} value={this.state.nomeComposto} 
                    onChange={(text) => { this.setState({nomeComposto: text})}
                } />


                    <SelectInput 
                    ref={this.selectRef}
                    value={this.state.insegnanti} 
                    name="Insegnanti" 
                    hidable={false}
                    options={this.state.insegnantiArray} 
                    isMulti={true}
                    onChange={(option) => 
                        this.setState({insegnanti: option})} 
                    />

                    <FixButton title={'OK'} callback={this.okClicked.bind(this)} />
            </div>
        </div>
        )
    }

    checkInvestor(investors, id){
        investors.map(v => {
            if (v.id == id) return true;
        });
        return false;
    }

    async okClicked(){

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });
        const currentEventId = cookies.get('currentEventId', { path: '/' });

        if (this.state.nomeComposto == ''){
            alert ("Occorre definire un nome per il gruppo di insegnanti");
            return;
        }

        if (!this.state.insegnanti || this.state.insegnanti.length < 2) {
            alert ("Il gruppo deve essere formato da almeno due insegnanti");
            return;
        }

        this.props.onOkClicked(this.state.nomeComposto, this.state.insegnanti);

    }
}


const menu = {
    position: 'relative',
    top: '10px',
    display: 'flex',
};

const menuVoice = {
    width: '50%',
    textAlign: 'center',
    border: '1px solid black',
    cursor: 'pointer'
}

const title = {
    top: '10xp',
    width: '100%',
    height: '40px',
    lineHeight: '40px',
    textAlign: 'center',
};

const closeIcon = {
    position: 'absolute', 
    cursor: 'pointer',
    right: 0, 
    top: 0, 
    padding: 10
}

const mainClass = {
    position: 'fixed',
    left: '35%',
    top: '10%',
    background: '#ffffff',
    border: '1px solid black',
    padding: '20px',
    zIndex: 999
}

const name = {
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}


const inputTextDisabled = {
    background: '#eeeeee',
    width: '300px',
    padding: '10px'
}